import { render, staticRenderFns } from "./ListManage.vue?vue&type=template&id=4adb82bc&scoped=true&"
import script from "./ListManage.vue?vue&type=script&lang=js&"
export * from "./ListManage.vue?vue&type=script&lang=js&"
import style0 from "./ListManage.vue?vue&type=style&index=0&id=4adb82bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adb82bc",
  null
  
)

export default component.exports